// ============================================
// COSMIC HINDU - API Base
// ============================================

const BASE_URL = import.meta.env.VITE_API_URL || 'https://cosmichindu.com/api';
const ADMIN_TOKEN_KEYS = ['ch_admin_token', 'admin_token'];
const CUSTOMER_TOKEN_KEYS = ['customer_token'];

function getStoredToken(keys) {
  for (const key of keys) {
    const value = localStorage.getItem(key);
    if (value) return value;
  }
  return null;
}

class ApiService {
  constructor() { this.baseUrl = BASE_URL; }

  getHeaders() {
    const headers = { 'Content-Type': 'application/json' };
    const token = getStoredToken(ADMIN_TOKEN_KEYS) || getStoredToken(CUSTOMER_TOKEN_KEYS);
    if (token) headers['Authorization'] = `Bearer ${token}`;
    return headers;
  }

  async request(url, options = {}) {
    try {
      const response = await fetch(url, { headers: this.getHeaders(), ...options });
      const data = await response.json().catch(() => ({ message: 'Request failed' }));
      if (!response.ok) throw new Error(data.message || `HTTP ${response.status}`);
      return data;
    } catch (err) {
      console.error('API Error:', url, err);
      throw err;
    }
  }

  get(file, params = {}) {
    const qs = Object.keys(params).length ? '?' + new URLSearchParams(params) : '';
    return this.request(`${this.baseUrl}/${file}${qs}`);
  }

  post(file, data) {
    return this.request(`${this.baseUrl}/${file}`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async upload(file, formData) {
    const headers = {};
    const token = getStoredToken(ADMIN_TOKEN_KEYS);
    if (token) headers['Authorization'] = `Bearer ${token}`;
    const response = await fetch(`${this.baseUrl}/${file}`, {
      method: 'POST', headers, body: formData,
    });
    const data = await response.json().catch(() => ({ message: 'Upload failed' }));
    if (!response.ok) throw new Error(data.message || `HTTP ${response.status}`);
    return data;
  }
}

export default new ApiService();
